(function() {
  'use strict';
  
  let isInitialized = false;
  
  function initCategoryMenu() {
    if (isInitialized) return;
    
    // 等待DOM完全加载
    const categoryItems = document.querySelectorAll('.menu-left li');
    const menuPanels = document.querySelectorAll('.menu-right-content');
    
    if (categoryItems.length === 0) {
      // 如果元素还没加载，延迟重试
      setTimeout(initCategoryMenu, 100);
      return;
    }
    
    isInitialized = true;
    
    // 确保第一个分类在页面加载时是激活状态
    if (categoryItems.length > 0) {
      categoryItems.forEach(cat => cat.classList.remove('active'));
      menuPanels.forEach(panel => {
        panel.classList.add('dis-hide-none');
        panel.classList.remove('dis-show');
      });
      
      categoryItems[0].classList.add('active');
      const firstPanel = document.getElementById('menu-right-content-1');
      if (firstPanel) {
        firstPanel.classList.remove('dis-hide-none');
        firstPanel.classList.add('dis-show');
      }
    }
    
    // 分类切换功能 - 使用鼠标悬停
    categoryItems.forEach(item => {
      item.addEventListener('mouseenter', function() {
        const categoryId = this.dataset.id;
        
        // 移除所有active类
        categoryItems.forEach(cat => cat.classList.remove('active'));
        menuPanels.forEach(panel => {
          panel.classList.add('dis-hide-none');
          panel.classList.remove('dis-show');
        });
        
        // 添加active类到当前悬停的项目
        this.classList.add('active');
        
        // 显示对应的内容面板
        const targetPanel = document.getElementById(`menu-right-content-${categoryId}`);
        if (targetPanel) {
          targetPanel.classList.remove('dis-hide-none');
          targetPanel.classList.add('dis-show');
        }
      });
      
      // 保持点击链接功能
      item.addEventListener('click', function(e) {
        // 如果点击的是链接，允许正常跳转
        const link = this.querySelector('a');
        if (link && e.target.tagName === 'A') {
          return true;
        } else {
          e.preventDefault();
        }
      });
    });
    
    // 添加菜单项悬停效果
    const menuItems = document.querySelectorAll('.t4s-type__category_split');
    menuItems.forEach(menuItem => {
      menuItem.addEventListener('mouseenter', function() {
        this.classList.add('is--hover');
      });
      
      menuItem.addEventListener('mouseleave', function() {
        this.classList.remove('is--hover');
      });
    });
  }
  
  // 多种初始化方式确保兼容性
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCategoryMenu);
  } else {
    initCategoryMenu();
  }
  
  // 页面完全加载后再次检查
  window.addEventListener('load', function() {
    setTimeout(initCategoryMenu, 50);
  });
  
  // 如果使用了Turbo或其他页面加载库，也监听这些事件
  document.addEventListener('shopify:section:load', initCategoryMenu);
  document.addEventListener('shopify:section:reorder', initCategoryMenu);
  
})();
